import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import InputFieldOutline from '../InputFieldOutline';
import s from './TextAreaInputField.scss';
/**
 * Our standard, plaintext `<textarea />` input.
 *
 * Allows indication of success or error via `validationResult`.
 */
var TextAreaInputField = React.forwardRef(function (_a, ref) {
    var className = _a.className, isRequired = _a.isRequired, validationResult = _a.validationResult, disabled = _a.disabled, rest = __rest(_a, ["className", "isRequired", "validationResult", "disabled"]);
    return (React.createElement(InputFieldOutline, { className: c(s['root'], className), outlineStyle: disabled ? 'disabled' : validationResult },
        React.createElement("textarea", __assign({ required: isRequired, className: s['input'], disabled: disabled, ref: ref }, rest))));
});
TextAreaInputField.displayName = 'TextAreaInputField';
export default TextAreaInputField;
//# sourceMappingURL=TextAreaInputField.js.map